
import React, { FC, useState, useEffect, useMemo } from 'react'
import { KTSVG, ID } from '../../../../_metronic/helpers'
import * as a from '../'

type Props = {
    id: ID
    fieldProps: any
    colSpan?: number
    backgroundColor?: string
}

export const TDCheckbox: React.FC<Props> = ({ id, colSpan, backgroundColor, fieldProps }) => {
    return (
        <td className={backgroundColor} colSpan={colSpan != undefined ? colSpan : 1}>
            <div className="form-check form-check-sm form-check-custom form-check-solid">
                <input className="form-check-input"
                    type="checkbox"
                    id={"chk" + id}
                    {...fieldProps}
                    checked={fieldProps.value}/>
            </div>
        </td>
    )
}